import { isGenericAnalytic } from "../../../Types/AnalysisDetails";
import { DataSource } from "../../../Types/DataSource";
import { ModalityGraphConfigJSON } from "../../../Types/Graph";
import { getFullTraceDataConfigs, RenderStrategy, TraceConfigJSON, TraceDataConfig } from "../../../Types/Trace";

export function traceDataIsAvailable(
    trace: TraceDataConfig,
    sourceModalities: Map<DataSource, string[]>,
): boolean {
    return (
        (sourceModalities.get(trace.dataSource) ?? []).includes(trace.rawDataKey)
        || (trace.onDemandAnalysis !== undefined && !isGenericAnalytic(trace.onDemandAnalysis.analytic))
    )
}

export function traceConfigIsAvailable(
    trace: TraceConfigJSON,
    sourceModalities: Map<DataSource, string[]>,
): boolean {
    if (trace.renderStrategy === RenderStrategy.DELTA) {
        return traceDataIsAvailable(trace.first, sourceModalities) && traceDataIsAvailable(trace.second, sourceModalities)
    }

    return traceDataIsAvailable(trace, sourceModalities)
}

export function getAvailableTraceDataConfigs(
    graphs: ModalityGraphConfigJSON[],
    sourceModalities: Map<DataSource, string[]>,
): TraceDataConfig[] {
    return [...new Set(graphs.flatMap(graph => graph.traces))]
        .flatMap(getFullTraceDataConfigs)
        .filter(trace => traceDataIsAvailable(trace, sourceModalities))
}

export function getVisibleGraphs<T extends ModalityGraphConfigJSON>(graphs: T[], sourceModalities: Map<DataSource, string[]>, hideEmptyGraphs: boolean) {
    if (!hideEmptyGraphs) {
        return graphs
    }

    return graphs.filter(graph => graph.traces
        .filter(trace => (trace.isVisible ?? true))
        .flatMap(getFullTraceDataConfigs)
        .some(trace => traceDataIsAvailable(trace, sourceModalities))
        )
}
